<div class="row my-3">
  <ng-container
    *ngFor="
      let field of [
        { id: 'make', name: 'make', label: 'Make', values: context.makes },
        { id: 'model', name: 'model', label: 'Model', values: context.models },
        {
          id: 'trim-type',
          name: 'trim_type',
          label: 'Trim/Type',
          values: context.trimType
        },
        {
          id: 'model-year',
          name: 'model_year',
          label: 'Model Year',
          values: context.modelYears
        },
        {
          id: 'exterior-color',
          name: 'exterior_color',
          label: 'Exterior Color',
          values: context.exteriorColor
        }
      ]
    "
  >
    <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
      <label [for]="field.id">{{ field.label }}</label>
      <select
        [id]="field.id"
        class="form-control"
        [name]="field.name"
        [value]="context.filterOptions[field.name] ?? ''"
        (change)="context.searchProductsFromList($event)"
      >
        <option value="" disabled selected>
          Please select {{ field.label | lowercase }}
        </option>
        <option *ngFor="let item of field.values | keyvalue" [value]="item.key">
          {{ item.key }} ({{ item.value }})
        </option>
      </select>
    </div>
  </ng-container>
  <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
    <label for="vin-number">VIN</label>
    <input
      id="vin-number"
      type="text"
      name="vin_number"
      class="form-control"
      placeholder="Please type a VIN"
      [value]="context.filterOptions['vin_number'] ?? ''"
      (input)="context.searchProductsFromList($event)"
    />
  </div>
  <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
    <label for="registration-number">Registration Number</label>
    <input
      id="registration-number"
      type="text"
      name="registration_number"
      class="form-control"
      placeholder="Please type a Registration number"
      [value]="context.filterOptions['registration_number'] ?? ''"
      (input)="context.searchProductsFromList($event)"
    />
  </div>
  <div class="col-12">
    <button
      *ngIf="context.Object.keys(context.filterOptions)?.length"
      (click)="context.resetFilter()"
      class="btn btn__main2 curved fw-500"
    >
      Reset
    </button>
  </div>
</div>
<div *ngIf="!context.isLoading">
  <p *ngIf="!context.tableData.length" class="m-0">No data found</p>
  <table
    datatable
    [dtOptions]="context.inventoryTableDtOptions"
    id="inventory"
    class="row-border hover m-0 w-100"
  >
    <thead>
      <tr>
        <th *ngFor="let thead of context.inventoryTableTheads">
          {{ thead }}
        </th>
      </tr>
    </thead>
    <tbody></tbody>
  </table>
</div>
